{
    "ReportPortalInfo_UpgradeTo_Enterprise": "Upgrade naar Enterprise om toegang te krijgen tot deze functie",
    "ReportPortalInfo_UpgradeTo_Enterprise_MST": "Upgrade naar CXA Advanced om toegang te krijgen tot deze functie",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor": "Upgrade naar Call Centre Supervisor om toegang te krijgen tot deze functie",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor_MST": "Upgrade naar CXE Advanced om toegang te krijgen tot deze functie",
    "NAME": "ReportPortalInfo"
}